module.exports = __webpack_public_path__ + "static/media/beta_dark_full.20305f91.svg";